import {useMutation, useQueryClient} from '@tanstack/react-query';
import conversationMessagesUpdaters from '@/api/updaters/conversationMessages';
import clearUnreadAfterMarkAllRead, {
  invalidateUnreadUiQueries,
} from './clearUnreadAfterMarkAllRead';

function useMarkAllRead() {
  const queryClient = useQueryClient();
  return useMutation<
    void,
    Error,
    {conversationId: string; campaignId?: string}
  >({
    mutationKey: ['conversations', 'markAllRead'],
    mutationFn: ({conversationId, campaignId}) =>
      conversationMessagesUpdaters.markAllRead(conversationId, campaignId),
    onSuccess: (_data, variables) => {
      clearUnreadAfterMarkAllRead(queryClient, variables);
      // Patch clears in-panel badges immediately; invalidate drops an
      // unread-filter row, refetches sidebar counts, and reconciles details.
      invalidateUnreadUiQueries(queryClient, variables);
    },
  });
}

export default useMarkAllRead;
